<template>
  <a-card :bordered="false">
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :label-col="currentFormLayout2.labelCol"
      :wrapper-col="currentFormLayout2.wrapperCol">
      <a-form-model-item label="活动名称" prop="fissionTitle">
        <a-input v-model="ruleForm.fissionTitle" :disabled="isExamine" style="width: 400px;" :maxLength="8"
                 placeholder="请输入"></a-input>
      </a-form-model-item>
      <a-form-model-item label="摘要" prop="fissionSummary">
        <a-input v-model="ruleForm.fissionSummary" :disabled="isExamine" style="width: 400px;" :maxLength="10"
                 placeholder="请输入"></a-input>
      </a-form-model-item>
      <a-form-model-item label="分享页封面图" prop="fissionUrl">
        <div class="upload-box">
          <a-upload
            :disabled="isExamine"
            :action="uploadFileUrl"
            :multiple="false"
            :showUploadList="false"
            listType="picture-card"
            @change="handleChange"
            :before-upload="beforeUploadFile"
          >
            <img v-if="ruleForm.fissionUrl" :src="ruleForm.fissionUrl" alt="avatar" class="selected-image"/>
            <div v-else>
              <a-icon type="plus"/>
              <br>上传
            </div>
          </a-upload>
          <span>
          温馨提示：建议图片长宽比为3:2，图片大小在750px*500px，格式.jpg、.png、.jpeg
        </span>
        </div>
      </a-form-model-item>
      <a-form-model-item label="活动规则" prop="fissionRule">
        <a-textarea
          v-model="ruleForm.fissionRule"
          :disabled="isExamine"
          :maxLength="200"
          placeholder="请输入"
          :auto-size="{ minRows: 3, maxRows: 5 }"
        />
      </a-form-model-item>
      <a-form-model-item label="关联优惠券" required>
        <a-button :disabled="isExamine" type="primary" @click="showCouponDialog">关联</a-button>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
        <a-table style="width:100%" :pagination="false" :columns="columns" :dataSource="couponList" rowKey="couponId">
          <span slot="action" slot-scope="text, record">
              <a style="color: red" v-if="!isExamine" @click="deleteCoupon(record.couponId)">移除</a>
            </span>
        </a-table>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
        <a-button :disabled="isExamine" @click="onSubmit" :loading="submitLoading" type="primary">提交</a-button>
        <a-button style="margin-left: 20px;" @click="goBack">返回</a-button>
      </a-form-model-item>
    </a-form-model>
    <selected-product-dialog
      title="选择优惠券"
      :show="showSelectedDialog"
      ref="pageList"
      :itemNames="['search_proName']"
      :buttonItems="['button_search']"
      :query-params="selectedQueryParams"
      :requestPromise="loadPromise"
      @close="showSelectedDialog=false"
      :columns="columns"
    >
      <a-form-item
        label="优惠券名称"
        slot="search_proName"
        v-bind="currentDialogLayout">
        <a-input
          v-model="selectedQueryParams.couponName"
          style="width: 170px"
          placeholder="请输入"
        ></a-input>
      </a-form-item>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'AddRedEnvelope',
  mixins: [ruleFormMixins],
  components: {
    SelectedProductDialog
  },
  data() {
    return {
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      serverUniqueId: this.$route.query.serverUniqueId,
      fissionId: this.$route.query.fissionId,
      serverId: this.$route.query.serverId,
      isExamine: this.$route.query.isExamine ? Boolean(this.$route.query.isExamine) : false,
      currentDialogLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 14 }
      },
      ruleForm: {
        fissionUrl: 'https://imgb.woyoubooking.com/common/icon_red_packet_home_bg.png',
        fissionTitle: '',
        fissionSummary: '',
        fissionRule: ''
      },
      selectedQueryParams: {
        couponMerchantId: this.$store.getters.userInfo.merchantId,
        couponName: '', // 优惠券名称
        fissionId: this.$route.query.fissionId ? this.$route.query.fissionId : '',
        couponPlatformId: this.getPlatformConfig().platformId
      },
      rules: {
        fissionTitle: [{ required: true, message: '请输入活动名称', trigger: 'change' }],
        fissionSummary: [{ required: true, message: '请输入活动摘要', trigger: 'change' }],
        fissionUrl: [{ required: true, message: '请上传分享页封面图', trigger: 'change' }],
        fissionRule: [{ required: true, message: '请输入活动规则', trigger: 'change' }]
      },
      uploadFileUrl: this.getUploadFileUrl(),//图片上传地址
      loading: false,
      submitLoading: false,
      columns: [
        {
          title: 'ID',
          dataIndex: 'couponId'
        },
        {
          title: '优惠券名称',
          dataIndex: 'couponName'
        },
        {
          title: '面额',
          dataIndex: 'couponAmout'
        },
        {
          title: '类型',
          dataIndex: 'couponUseTypeStr'
        },
        {
          title: '优惠券状态',
          dataIndex: 'couponStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      showSelectedDialog: false,
      loadPromise: params => this.getListPromise(params),
      couponList: []
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'FissionRedEnvelope', title: '活动列表' }
    ])
    if (this.fissionId) {
      this.getDetails()
      this.getCouponList()
    }
  },
  methods: {
    showCouponDialog() {
      this.showSelectedDialog = true
      this.$nextTick(function() {
        this.$refs.pageList.refresh(true)
      })
    },
    deleteCoupon(couponId) {
      const couponList = [...this.couponList]
      this.couponList = couponList.filter(item => item.couponId !== couponId)
    },
    goBack() {
      this.$router.back(-1)
    },
    getDetails() {
      this.getHttpServices().getServerApiService().get('fission/get?fissionId=' + this.fissionId)
        .then(res => {
          this.ruleForm.fissionTitle = res.fissionTitle
          this.ruleForm.fissionSummary = res.fissionSummary
          this.ruleForm.fissionUrl = res.fissionUrl
          this.ruleForm.fissionRule = res.fissionRule
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getCouponList() {
      let params = {
        couponMerchantId: this.merchantId,
        couponPlatformId: this.platformId,
        fissionId: this.fissionId,
        couponName: ''
      }
      this.getHttpServices().getServerApiService().post('fission/findCouponSettingListByFissionId', params)
        .then(res => {
          this.couponList = res
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getListPromise(params) {
      if (this.couponList && this.couponList.length > 0) {
        params.bindCouponIdList = this.couponList.map(obj => {
          return obj.couponId
        })
      }
      return this.getHttpServices().getServerApiService().post('fission/findCouponSettingListBindFissionId', params)
    },
    onSelectedResult(data) {
      let result = this.couponList.some(function(item) {
        if (item.couponId == data.couponId) {
          return true
        }
      })
      if (result) {
        this.$message.error('请勿重复选择同一优惠券')
        return
      }
      this.couponList.push(data)
      this.$message.success('选择成功')
      this.showSelectedDialog = false
    },
    getUploadFileUrl() {
      let appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      if (this.couponList.length === 0) {
        this.$message.error('请关联优惠券')
        return
      }
      this.submitLoading = true
      let params = {
        fissionPlatformId: this.platformId,
        fissionMemberId: this.merchantId,
        fissionTitle: this.ruleForm.fissionTitle,
        fissionSummary: this.ruleForm.fissionSummary,
        fissionUrl: this.ruleForm.fissionUrl,
        fissionRule: this.ruleForm.fissionRule
      }
      let msg = this.fissionId ? '修改成功' : '新建成功'
      if (this.fissionId) {
        params.fissionId = this.fissionId
      }
      if (this.couponList && this.couponList.length > 0) {
        params.couponIdList = this.couponList.map(obj => {
          return obj.couponId
        })
      }
      this.getHttpServices().getServerApiService().post('fission/save', params)
        .then(res => {
          this.$message.success(msg)
          this.goBack()
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => {
          setTimeout(() => {
            this.submitLoading = false
          }, 500)
        })
    },
    beforeUploadFile(file) {
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG && !isJPEG) {
        this.$message.error('请选择正确的图片格式上传!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!')
        return false
      }
      return true
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        this.ruleForm.fissionUrl = this.getLatestUrlFromFileList(info.fileList)
        this.loading = false
      }
    },
    getLatestUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        const lastIndex = fileList.length - 1
        if (fileList[lastIndex] && fileList[lastIndex].response) {
          return fileList[lastIndex].response.data
        }
      }
      return ''
    }
  }
}
</script>

<style scoped>
.upload-box {
  display: flex;
  justify-content: flex-start;
}

.ant-upload-picture-card-wrapper {
  width: 200px;
}

.selected-image {
  width: 150px;
  height: 100px;
}
</style>